<template>
    <div class="location-intro">
        <div class="location-intro--header">
            <h1 class="location-intro--title" v-text="content.title"></h1>
            <cmp-icon class="location-intro--icon" :symbol="content.icon" size="large"></cmp-icon>
        </div>

        <img v-if="image.url"
                class="location-intro--title-image"
                :src="image.url" :alt="image.alt">
        <!--
        <cmp-tinted-image class="location-intro--title-image"
                v-if="image.url"
                facet="location-intro"
                :is-inert="true"
                :img="image">
        </cmp-tinted-image>
        -->

        <div class="location-intro--lead" v-html="content.lead"></div>

        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPluginMixin,
        ],
        computed: {
            image() {
                return this.content.image || {};
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/location-intro/index.vue?1bd6e9e2